module.exports = __webpack_public_path__ + "img/db-khoan-no-thu.f020292d.svg";